import ReducerBuilder from "../../../classes/ReducerBuilder";
import initialState from "./initialState";
import {Types} from "./actions";
import {isNoU, clone} from "../../../utils/DBUtils";
import dotProp from 'dot-prop';

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.START_EDIT_BREAK_TAG)
    .reduce((state, action) => {
        if (isNoU(action.tag.id)) {
            state.creatingTag = true;
        } else {
            state.editingTag = true;
            // for dif later
            state.originalTag = clone(action.tag);
        }

        state.tag = action.tag;
        state.postCreateAction = action.postCreateAction;
        state.postEditAction = action.postEditAction;
    })
    .forType(Types.SUBMIT_BREAK_TAG_EDIT)
    .reduce((state) => {
        state.submitting = true;
    })
    .forType(Types.END_EDIT_BREAK_TAG)
    .reduce((state) => {
        state.creatingTag = false;
        state.editingTag = false;
        state.tag = null;
        state.originalTag = null;
        state.submitting = false;
        state.fieldErrors = {};
    })
    .forType(Types.UPDATE_BREAK_TAG_FIELD_ERROR)
    .reduce((state, {field, error, value}) => {
        state.fieldErrors[field] = error;
        dotProp.set(state.tag, field, value);
    })
    .build();

export default reducer;


// WEBPACK FOOTER //
// ./public/pages/EditBreak/BreakTagModal/reducer.js